import { render, staticRenderFns } from "./NoticeCheck.vue?vue&type=template&id=1318f996&scoped=true&"
import script from "./NoticeCheck.vue?vue&type=script&lang=js&"
export * from "./NoticeCheck.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCheck.vue?vue&type=style&index=0&id=1318f996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1318f996",
  null
  
)

export default component.exports